import "core-js/modules/es6.function.name";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.object.values";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import { ElementMapper } from './element.mapper';
export var ItemMapper =
/*#__PURE__*/
function () {
  function ItemMapper(config) {
    _classCallCheck(this, ItemMapper);

    this.config = config;
    this.elementMapper = new ElementMapper(config);
  }
  /**
   * Maps single item to its proper strongly typed model from the given response
   * @param response Response used to map the item
   * @param queryConfig Query configuration
   */


  _createClass(ItemMapper, [{
    key: "mapSingleItemFromResponse",
    value: function mapSingleItemFromResponse(response) {
      var mapResult = this.mapItems({
        mainItems: [response.item],
        linkedItems: Object.values(response.modular_content)
      });
      return {
        item: mapResult.items[0],
        linkedItems: mapResult.linkedItems
      };
    }
    /**
     * Maps multiple items to their strongly typed model from the given  response
     * @param response Response used to map the item
     * @param queryConfig Query configuration
     */

  }, {
    key: "mapMultipleItemsFromResponse",
    value: function mapMultipleItemsFromResponse(response) {
      var mapResult = this.mapItems({
        mainItems: response.items,
        linkedItems: Object.values(response.modular_content)
      });
      return mapResult;
    }
    /**
     * Maps item contracts to full models
     */

  }, {
    key: "mapItems",
    value: function mapItems(data) {
      var that = this;
      var processedItems = {};
      var preparedItems = {};
      var processingStartedForCodenames = [];
      var mappedMainItems = [];
      var mappedLinkedItems = {};
      var itemsToResolve = [].concat(_toConsumableArray(data.mainItems), _toConsumableArray(data.linkedItems)); // first prepare reference for all items

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = itemsToResolve[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;
          preparedItems[item.system.codename] = {
            item: this.createContentItem(item),
            rawItem: item
          };
        } // then resolve items

      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = data.mainItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _item = _step2.value;
          var itemResult = that.mapItem({
            item: preparedItems[_item.system.codename],
            processedItems: processedItems,
            preparedItems: preparedItems,
            processingStartedForCodenames: processingStartedForCodenames
          });
          mappedMainItems.push(itemResult.item);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
            _iterator2["return"]();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = data.linkedItems[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _item2 = _step3.value;

          var _itemResult = that.mapItem({
            item: preparedItems[_item2.system.codename],
            processedItems: processedItems,
            preparedItems: preparedItems,
            processingStartedForCodenames: processingStartedForCodenames
          });

          mappedLinkedItems[_item2.system.codename] = _itemResult.item;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
            _iterator3["return"]();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return {
        items: mappedMainItems,
        linkedItems: mappedLinkedItems
      };
    }
    /**
     * Maps item contract to full model
     */

  }, {
    key: "mapItem",
    value: function mapItem(data) {
      if (!data.item) {
        throw Error("Could not map item because its undefined");
      }

      var result = this.elementMapper.mapElements({
        dataToMap: data.item,
        preparedItems: data.preparedItems,
        processingStartedForCodenames: [],
        processedItems: data.processedItems
      });

      if (!result) {
        throw Error("Mapping of content item '".concat(data.item.item.system.codename, "' failed"));
      }

      return {
        item: result.item,
        processedItems: result.processedItems,
        preparedItems: result.preparedItems,
        processingStartedForCodenames: result.processingStartedForCodenames
      };
    }
  }, {
    key: "createContentItem",
    value: function createContentItem(item) {
      var _a;

      var contentItem = {
        elements: {},
        system: {
          codename: item.system.codename,
          collection: item.system.collection,
          id: item.system.id,
          language: item.system.language,
          lastModified: item.system.last_modified,
          name: item.system.name,
          sitemapLocations: item.system.sitemap_locations,
          type: item.system.type,
          workflowStep: (_a = item.system.workflow_step) !== null && _a !== void 0 ? _a : null
        }
      };
      return contentItem;
    }
  }]);

  return ItemMapper;
}();